import SingleRolesView from "./single-role-view.jsx";

export default SingleRolesView;